/** API route map: URLS.Controller.PayrollReview */
export const PayrollReview = {
      Name: 'PayrollReview/',
      GetAll: 'get-all',
      AddReview: 'add-review',
      GetReviews: 'get-reviews',
      Approve: 'approve',
};
